import { useLoginInfo } from 'app/_hooks'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

type Opts = {
  notSignedIn: string
  noProfile: string
  conflict: string
  onRedirect?: () => void
}

export const useLoginCheck = () => {
  const loginInfo = useLoginInfo()
  const { push } = useRouter()

  return useCallback(
    (opts: Opts): boolean => {
      switch (loginInfo.status) {
        case 'notSignedIn':
          if (confirm(opts.notSignedIn)) {
            void push('/login')
            opts.onRedirect?.()
          }
          return false
        case 'noProfile':
          alert(opts.noProfile)
          return false
        case 'conflict':
          alert(opts.conflict)
          return false
        case 'signedIn':
          return true
        default:
          return false
      }
    },
    [loginInfo, push],
  )
}
